import { useEffect, useState, useCallback, useRef } from 'react';
import LoginService from './../services/LoginService';

const useServerTime = (refetch, interval) => {
    const [serverTime, setServerTime] = useState();
    const [counter, setCounter] = useState(0);
    const mounted = useRef();

    useEffect(() => {
        if (interval) {
            let intervalId;
            if (serverTime) {
                intervalId = setInterval(
                    () =>
                        setCounter(
                            currentCounter =>
                                +(currentCounter
                                    ? currentCounter
                                    : serverTime) + 1000
                        ),
                    1000
                );
            }
            return () => intervalId && clearInterval(intervalId);
        }
    }, [interval, serverTime]);

    const fetchServerTime = useCallback(async () => {
        const response = await new LoginService().serverTime();
        if (response?.body) {
            const responseTime = JSON.parse(response.body).Result;
            if (mounted.current) {
                setServerTime(responseTime);
            }
        }
    }, []);

    useEffect(() => {
        mounted.current = true;
        fetchServerTime();

        let documentHiddenRef = document.hidden;

        const refetchTimeOnTabFocus = () => {
            if (documentHiddenRef !== document.hidden) {
                if (!document.hidden) {
                    fetchServerTime();
                }
                documentHiddenRef = document.hidden;
            }
        };

        document.addEventListener('visibilitychange', refetchTimeOnTabFocus);

        return () => {
            document.removeEventListener(
                'visibilitychange',
                refetchTimeOnTabFocus
            );
            mounted.current = false;
        };
    }, [fetchServerTime, refetch]);

    return { serverTime, counter, fetchServerTime };
};

export default useServerTime;
